import { SanitySharesTable } from '../../types/generated/graphql-types'
import { SharesTableProps } from '../components/SharesTable'
import { notEmpty } from '../utilities/filters'

export const sanitySharesTableToSharesTableProps = ({
  footnotes,
  rows,
  title,
  disableSort,
}: SanitySharesTable): SharesTableProps => ({
  footnotes: footnotes?.filter(notEmpty),
  rows:
    rows?.filter(notEmpty).map(row => ({
      cells:
        row.cells?.filter(notEmpty).map(cell => ({
          content: cell._rawContent?.filter(notEmpty) ?? [],
        })) ?? [],
    })) ?? [],
  title: title ?? undefined,
  enableSort: !disableSort ?? true,
})
